export const staticGlobtroterPaths = {
  news: '/news',
  userProfile: '/user-profile',
  changePassword: '/user-profile/change-password',
  logout: '/user-profile/logout',
};
